export default "__VITE_ASSET__BEo$3F0u__"